export default __webpack_public_path__ + "static/media/tick.1a9902a0.svg";